module.exports = __webpack_public_path__ + "b16453960ba2afa303b8ec27fdc2d911.svg";